import React from "react";
import { Box, Button, ButtonGroup } from "@mui/material";
import Text from "components/common/Text";

const HeatmapHeader = ({
  title,
  activeTab = "portfolio",
  onPortfolioClick,
  onNiftyClick,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        flexDirection: { xs: "column", sm: "row" },
        gap: { xs: 1.5, sm: 0 },
        px: 2,
        pt: 2,
      }}
    >
      <Text
        sx={{
          fontWeight: 500,
          fontSize: { xs: 16, sm: 18 },
        }}
      >
        {title}
      </Text>

      <Box
        sx={{
          width: { xs: "100%", sm: "auto" },
          pb: 2,
          display: "flex",
          justifyContent: { xs: "flex-end", sm: "flex-start" },
        }}
      >
        <ButtonGroup>
          <Button
            onClick={onPortfolioClick}
            sx={{
              backgroundColor:
                activeTab === "portfolio" ? "#2B70C5" : "transparent",
              color: activeTab === "portfolio" ? "#fff" : "#2B70C5",
              fontSize: { xs: 12, sm: 14 },
              border:
                activeTab === "portfolio"
                  ? "none"
                  : "1px solid #2B70C5",
            }}
          >
            Jarvis Portfolio
          </Button>

          <Button
            onClick={onNiftyClick}
            sx={{
              backgroundColor:
                activeTab === "nifty" ? "#2B70C5" : "transparent",
              color: activeTab === "nifty" ? "#fff" : "#2B70C5",
              fontSize: { xs: 12, sm: 14 },
              border: "1px solid #2B70C5",
            }}
          >
            Nifty
          </Button>
        </ButtonGroup>
      </Box>
    </Box>
  );
};

export default HeatmapHeader;
